var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-admin-tasks__new-table-cell page-admin-tasks__new-table-cell-status"},[(_vm.label)?_c('span',{staticClass:"page-admin-tasks__table-cell-status-tag",class:_vm.tagClass},[_vm._v(_vm._s(_vm.label))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }